import type { Size } from './sideBarDialog.type';

export const SIZE = {
  xSmall: '20rem',
  small: '26rem',
  medium: '29rem',
  large: '32rem',
  xLarge: '40rem',
} as Record<Size, string>;

export const MARGIN_TOP_TOOLBAR = '4.25rem';

export const MARGIN_BOTTOM_TOOLBAR = '3.625rem';
